export const toBinaryGenes = (genes: string) => {
  return BigInt(genes).toString(2).padStart(256, "0");
};
